/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Desc_FirefliesInputs */



/**
* | output |
* | --- |
* | "Meeting transcripts and summaries, searchable." |
*
* @param {Spaces_Gallery_Desc_FirefliesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_gallery_desc_fireflies = /** @type {((inputs?: Spaces_Gallery_Desc_FirefliesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Desc_FirefliesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Meeting-Transkripte und Zusammenfassungen, durchsuchbar.")
	return /** @type {LocalizedString} */ ("Meeting transcripts and summaries, searchable.")
});